import Swal from "sweetalert2";

export const swalErrorMessage = (text = '') => {
  Swal.fire({
    title: 'Error!',
    text,
    icon: 'error'
  })
}
